export const actionGroupName: string = 'Settings';
